import * as React from 'react';
import type { NextPage } from 'next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import background from '@/assets/img/background.svg';
import logo from '@/assets/img/logoPrincipal.svg';
import { Toast } from '@/lib/Toast';
import { api } from '@/services/apiClient';
import { isAllowedNextUrl } from '@/utils';
import { Box, Button, Divider, TextField, Typography } from '@mui/material';
import { Theme } from '@mui/system';

const ForgotMyPassword: NextPage = () => {
  const router = useRouter();
  const { next } = router.query;
  const [email, setEmail] = React.useState('');

  const handleForgotMyPassword = () => {
    api
      .post(
        '/auth/users/reset_password/',
        {
          email,
          ...(next &&
            isAllowedNextUrl(next.toString()) && { next_url: next.toString() }),
        },
        { headers: { Authorization: '' } }
      )
      .then(response => {
        if (response.status === 204) {
          Toast(
            'success',
            'Se esse email estiver vinculado a uma conta, foi enviado com sucesso!'
          );
        }
      })
      .catch(error => {
        if (error.response?.status === 400) {
          if (error.response.data?.email) {
            Toast('error', error.response.data.email[0]);
          }
        } else {
          Toast('error', 'Houve um erro ao enviar o email');
        }
      });
  };

  return (
    <>
      <Box
        display="flex"
        width="100%"
        height="100vh"
        flexDirection="column"
        sx={{
          backgroundImage: `url(${background.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <Box display="flex" justifyContent="center" sx={{ height: '50%' }}>
          <Image height="130px" src={logo} alt="Logo" />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          sx={{
            backgroundColor: '#FFFFFF',
            height: '50%',
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderRadius: '20px 20px 0 0',
            padding: 2,
          }}
        >
          <Box
            sx={(theme: Theme) => ({
              maxWidth: theme.breakpoints.values.sm,
              width: '100%',
            })}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              sx={{ marginBottom: 2 }}
            >
              <Divider sx={{ flex: 1 }} />
              <Typography
                variant="h6"
                color="primary"
                sx={{ marginLeft: 3, marginRight: 3 }}
              >
                Esqueci minha senha
              </Typography>
              <Divider sx={{ flex: 1 }} />
            </Box>
            <Typography
              variant="subtitle2"
              color="primary"
              sx={{ marginBottom: 2 }}
            >
              Preencha seu e-mail
            </Typography>
            <TextField
              sx={{ marginBottom: 3 }}
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ width: '100%' }}
              label={<span style={{ fontSize: '0.875rem' }}>E-mail</span>}
              variant="outlined"
              required
            />
            <Button
              variant="contained"
              onClick={() => handleForgotMyPassword()}
              sx={{ width: '100%', marginBottom: 3 }}
            >
              Recuperar Senha
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                router.push('/login');
              }}
              sx={{ width: '100%' }}
            >
              Voltar
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ForgotMyPassword;
